
// Libraries
import { Component, Vue, Prop } from "nuxt-property-decorator";

// Components
import SingleRating from "~/components/molecules/display/ratings/SingleRating.vue";
import ProgressBar from "~/components/molecules/display/ProgressBar.vue";

@Component({
  components: {
    SingleRating,
    ProgressBar,
  },
})
export default class UserRatingCollectionMolecule extends Vue {
  @Prop() userRatingData: {
    averageRating: number;
    countRating: number;
    ratingsLastYear: {
      countRating: number;
      averageRating: number;
      fiveStarRatings: number;
      fourStarRatings: number;
      threeStarRatings: number;
      twoStarRatings: number;
      oneStarRatings: number;
    };
  };

  getRatingsPercentageShare(ratingsQuantity) {
    if (ratingsQuantity === null) return 0;
    let percentageShare =
      (ratingsQuantity / this.userRatingData.ratingsLastYear.countRating) * 100;
    if (percentageShare > 0) return percentageShare.toFixed(0);
    return 0;
  }
}
